import { IGetSpendingsParams, IGetSpendingsResponse } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { web3Api } from 'store/queries';
import { featureConfig } from 'modules/common/featureConfig';

import { fetchUserSpendingsMock } from './mocks/fetchUserSpendings';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchUserSpendings },
  useFetchUserSpendingsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchUserSpendings: build.query<IGetSpendingsResponse, IGetSpendingsParams>(
      {
        queryFn: createNotifyingQueryFn(async params => {
          if (featureConfig.offlineTesting) {
            return { data: await fetchUserSpendingsMock() };
          }

          const service = MultiService.getService();

          const data = await service
            .getAccountingGateway()
            .getUserSpendings(params);

          return { data };
        }),
      },
    ),
  }),
  overrideExisting: true,
});
